export default __webpack_public_path__ + "static/media/banner1.4888715d.png";